import { LightningElement, api } from "lwc";
import { getAssetsUrl, attrToBool } from "common/helpers";

var avatarPlaceholder =
  "data:image/svg+xml,%3Csvg%20enable-background%3D%22new%200%200%20180%20181%22%20viewBox%3D%220%200%20180%20181%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2290%22%20cy%3D%2290%22%20fill%3D%22%23f5f5f5%22%20r%3D%2290%22%2F%3E%3Cpath%20d%3D%22m119.7%20144.7c2.1-.8%203.2-1.4%203.2-1.4%2038.1-24.1%2031.9-54.8%2013.7-79.1%208.1-45.7-21.7-21.9-27.8-16.6-17.3-4-34.4-1.3-34.4-1.3-1.5%200-2.9.2-4.3.3-5.8-5.4-34.9-30.4-28.4%2015.4-1%201.2-1.6%202-1.6%202-34.3%2049.3%2014.6%2077.8%2014.6%2077.8.9.4%201.9.8%202.8%201.2-4.5.5-9.9%202.2-14.2%205-2.8%201.8-6.9%204.2-10.4%2012%2015.5%2012.7%2035.4%2020.4%2057%2020.4%2020%200%2038.5-6.5%2053.5-17.6-5.9-12.3-17.1-16.3-23.7-18.1z%22%20fill%3D%22%23e9e9e9%22%2F%3E%3Cpath%20d%3D%22m46.1%2062c-3.4-4.3-2.9-20%203.1-22%201.7-.1%203.3.4%204.7%201.4%200%200%2013%2011.3%206.2%2018-5.9%205.8-11.8%205.4-14%202.6z%22%20fill%3D%22%23dedede%22%2F%3E%3Cpath%20d%3D%22m36.7%2076s-20.9%2038.4%2017.3%2060c0%200-30.2-26-17.3-60z%22%20fill%3D%22%23dedede%22%2F%3E%3Cpath%20d%3D%22m134.9%2047.1c-.4-1.1-.9-2.2-1.6-3.1-.6-.9-1.5-1.5-2.4-1.9h-.1-.1c-.2%200-.4%200-.6%200-.7%200-1.4.1-2%20.2-.9.2-1.7.6-2.4%201.2-1.5%201.3-3%202.8-4.3%204.3-1.1%201.3-2.1%202.8-3%204.3s-1.4%203.2-1.5%205c0%201.9.7%203.7%202%205%203.3%203.5%206.7%205%209.5%205%201.9.1%203.7-.6%205-2%20.9-1.2%201.5-2.6%201.8-4.1.4-1.9.7-3.8.7-5.7.2-2.9-.2-5.6-1-8.2z%22%20fill%3D%22%23dedede%22%2F%3E%3Cpath%20d%3D%22m134%20103.6c.4%2016.1-12%2030.1-29.6%2035.3-4.4%201.3-8.9%202-13.5%202.1-18.9.5-35.2-8.8-41.8-22.4-.2-.4-.4-.8-.5-1.2-1.6-3.6-2.5-7.5-2.6-11.5-.5-20%2019.6-37.3%2043.9-37.9%204.4-.1%208.7.3%2012.9%201.3%2017.9%204.2%2030.7%2018%2031.2%2034.3z%22%20fill%3D%22%23f8f8f8%22%2F%3E%3Cg%20fill%3D%22%23dbdbdb%22%3E%3Cellipse%20cx%3D%2268.5%22%20cy%3D%22115%22%20rx%3D%226.5%22%20ry%3D%224%22%20transform%3D%22matrix%28.07167154%20-.9974%20.9974%20.07167154%20-51.1137%20175.0816%29%22%2F%3E%3Cellipse%20cx%3D%22108.5%22%20cy%3D%22118%22%20rx%3D%226.5%22%20ry%3D%224%22%20transform%3D%22matrix%28.07167154%20-.9974%20.9974%20.07167154%20-16.9729%20217.7637%29%22%2F%3E%3Cpath%20d%3D%22m52.8%20124s-4-25.6%202.4-26.3c0%200%203.3%204.2%205.5%204.2.4%200-1.5-13%205.4-17.1%200%200%2024.8%209.6%2027.6%203.9-.9-.5-10-3.9-9.6-7.9.2-2.2%2019.5-2.1%2028%2016.7%201.4.8%203.6-2.8%204.1-8%20.9-9.7%207.9%2016.3%208.1%2016.7.1.4%202-.6%203.7-3%201.6-2.4%201.1%2015.6.8%2017.5-.3%201.8%206.3-7.7%205.2-19.9s-11.9-25-21.3-28.8c-8.9-3.6-24-10.2-47.1%201.8-24.7%2012.8-18.9%2039-18.8%2039.4.6%203.1%205%2010.6%206%2010.8z%22%2F%3E%3Cpath%20d%3D%22m89.5%20180.5c5.2%200%2010.4-.5%2015.4-1.3-.6-9.1-.7-24.2-17.4-24.2-17.9%200-17.7%2013.7-18.3%2023.2%206.6%201.5%2013.3%202.3%2020.3%202.3z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

const DEFAULT_COLOR = "#0070d2";
class avatar extends LightningElement {
  @api assistiveText = "";
  @api variant = "user";
  @api imageVariant = "circle";
  @api size = "medium";
  @api imgSrc = null;
  @api color = DEFAULT_COLOR;
  @api loading = null;
  @api title = "";
  @api subtitle = null;
  @api titleHref = null;
  @api titleTarget = null;
  @api removeTruncate = false;

  get imgSrcWithDefault() {
    return this.imgSrc ?? getAssetsUrl(avatarPlaceholder);
  }

  get titleIsLink() {
    return !!this.titleHref;
  }

  get isUser() {
    return this.variant === "user";
  }

  get isOrg() {
    return this.variant === "org";
  }

  get style() {
    return this.isOrg ? `background-color: ${this.color || DEFAULT_COLOR}` : "";
  }

  get className() {
    return `avatar avatar--${this.size} avatar--${this.variant} avatar--${this.imageVariant}`;
  }

  get isLoading() {
    return typeof this.loading === "boolean"
      ? this.loading
      : this.loading !== null;
  }

  get containerClassName() {
    return this.title ? `flex align-items-center` : ``;
  }

  get subtitleClassName() {
    return attrToBool(this.removeTruncate) ? `subtitle` : `subtitle truncate`;
  }

  get titleClassName() {
    return attrToBool(this.removeTruncate) ? "title" : "title truncate";
  }
}

export default avatar;
